import vuetify from '@/plugins/vuetify';
import services from '@/services/index';
import Cookies from 'js-cookie';
import color from 'color';
import BigNumber from 'bignumber.js';
const isWindows = window.navigator.appVersion.indexOf('Win') !== -1;
const isTouch = Boolean('ontouchstart' in document.documentElement);
export default {
    services,
    getColor(name) {
        const currentTheme = vuetify.userPreset.theme.dark ? 'dark' : 'light';
        const iters = name.split('.');
        let result = vuetify.userPreset.theme.themes[currentTheme];
        for (let i = 0; i < iters.length; i++) {
            result = result[iters[i]];
        }
        if (result)
            return result;
        else
            throw new Error('Color name "' + name + '" not found in pallet');
    },
    $isElectron: process.platform !== 'browser',
    $cookies: Cookies,
    isWindows,
    isTouch,
    isDesktopWindows: isWindows && !isTouch && window.screen.width >= 1023,
    NS: BigNumber,
    $color: color,
    log() {
        console.log(...arguments);
    }
};
